function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter0_d)"
}, React.createElement("path", {
  fill: "#FF5C61",
  d: "M12 14.1958c0-2.6419 0-3.9628.4316-5.00483a5.67016 5.67016 0 013.0686-3.06857c1.042-.4316 2.3629-.4316 5.0048-.4316h17.0099c2.6419 0 3.9629 0 5.0049.4316 1.3893.57547 2.4931 1.67927 3.0685 3.06857.4316 1.04203.4316 2.36293.4316 5.00483v17.0099c0 2.6419 0 3.9629-.4316 5.0048a5.66917 5.66917 0 01-3.0685 3.0686c-1.042.4316-2.363.4316-5.0049.4316H20.505c-2.6419 0-3.9628 0-5.0048-.4316-1.3893-.5754-2.4931-1.6792-3.0686-3.0686C12 35.1686 12 33.8476 12 31.2057V14.1958z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M31.0713 29.7883h3.6171l5.1322-14.175h-3.9075l-4.8418 14.175zM28.3877 18.5887l-2.4496 8.0496-3.675-11.025h-4.0248l5.1909 14.175h4.8418l3.8504-11.1996h-3.7337z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_d",
  width: 56.6999,
  height: 56.6999,
  x: 0.66002,
  y: 0.02081,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 5.66999
}), React.createElement("feGaussianBlur", {
  stdDeviation: 5.66999
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 58 45",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.13ea6854.svg";
export { ForwardRef as ReactComponent };